<template>
  <div class="pageContainer">
    <div class="stuTrainProgramCont">
      <div class="topCont">
        <div class="title">
          浙江大学培养方案概览
        </div>
<!--        <div class="searchCont">-->
<!--          <el-input placeholder="输入专业名称" class="input-with-select">-->
<!--            <el-button slot="append" type="primary">定位</el-button>-->
<!--          </el-input>-->
<!--        </div>-->
      </div>
      <ul class="middleCont">
        <li v-for="(item,index) in planningList" :key="index">
          <div class="stepTitle">{{ item.name }}&nbsp;&nbsp;>></div>
          <div class="splitLine"/>
          <div class="majorBox">
            <div class='majorName' v-for="(obj,inIndex) in item['majors']"
                 :key="index+inIndex">
              <el-popover
                placement="bottom"
                width="300"
                trigger="hover">
                <div class="gradeBox">
                  <div class="gradeInfo" v-for="(gradeInfo,keyIndex) in obj.grades" :key="inIndex+keyIndex" @click="toStuCourse(gradeInfo)">
                    {{ gradeInfo.name }}
                  </div>
                </div>
                <span slot="reference">{{ obj.name }}</span>
              </el-popover>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import trainUse from '../../../api/trainUse'
import {mapMutations} from "vuex";

export default {
  name: 'StuTrainProgram',
  components: {},
  computed: {},
  data() {
    return {
      loading: false,
      planningList: [],
    }
  },
  created() {

  },
  mounted() {
    trainUse.academicPlanningList().then(res => {
      if (res && res.code === 10000) {
        this.planningList = res.data
      }
    })
  },
  methods: {
    ...mapMutations('trainUse', ['saveStuCourseData']),
    toStuCourse(data) {
      this.$router.push('stuCourse')
      this.saveStuCourseData(data)
    }
  },

}
</script>

<style lang="less" scoped>

.pageContainer {
  width: 100%;
  min-height: 100%;
  background-color: #f4f4f4;
  padding: 35px 120px;
  box-sizing: border-box;

  .stuTrainProgramCont {
    background-color: #fff;
    padding: 25px 30px;
    min-height: 100%;

    .topCont {
      margin-bottom: 42px;
      //display: flex;
      //justify-content: center;
      //margin: 0 auto 20px auto;
      .title {
        width: 100%;
        height: 60px;
        background-color: #4b9cfc;
        text-align: center;
        line-height: 60px;
        margin: 0 auto 30px;
        color: #fff;
        font-size: 21px;
        font-weight: 600;
      }

      .searchCont {
        width: 300px;
        float: right;
      }

      &::after {
        display: block;
        clear: both;
        content: "";
        visibility: hidden;
        height: 0
      }
    }

    .middleCont {
      li:not(:last-child) {
        margin-bottom: 15px;
        padding-bottom: 8px;
        //border-bottom: 1px solid #e0e0e0;
      }

      .stepTitle {
        //margin-bottom: 10px;
        text-align: center;
        width: 180px;
        height: 30px;
        line-height: 30px;
        color: #fff;
        background-color: #95c5fd;
        margin-bottom: 10px;
      }

      .splitLine {
        width: 100%;
        //border-bottom: 1px solid #95c5fd;
        border-bottom: 1px solid rgba(147, 197, 253, 0.7);
      }

      .majorBox {
        display: flex;
        flex-wrap: wrap;
        padding: 20px 60px;

        .majorName {
          width: 160px;
          margin-right: 10px;
          margin-bottom: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 32px;
          //text-align: center;
          cursor: pointer;
          padding: 0 15px;
          font-size: 14px;
          border-radius: 4px;
          color: rgba(0, 0, 0, 0.65);
          background-color: rgb(255, 255, 255);

          &:hover {
            color: rgb(64, 169, 255);
            background-color: rgb(255, 255, 255);
            border-color: rgb(64, 169, 255);
          }

          .checked {
            color: rgb(64, 169, 255);
            background-color: rgb(255, 255, 255);
            border-color: rgb(64, 169, 255);
          }

        }
      }

    }

  }
}

.el-popover {
  .gradeBox {
    padding: 12px;
    display: flex;
    flex-wrap: wrap;

    .gradeInfo {
      width: 75px;
      height: 40px;
      color: #fff;
      margin-right: 12px;
      margin-bottom: 12px;
      text-align: center;
      line-height: 40px;
      background-color: #aed1fe;
      border-radius: 5px;
      cursor: pointer;
    }
  }
}

</style>
